var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex relative items-center", class: _vm.ckickableClass },
    [
      _c(
        "div",
        {
          staticClass: "flex-shrink-0",
          class: _vm.avatarOnly ? "tooltip" : "",
        },
        [
          _vm.image
            ? [
                _vm._t(
                  "image",
                  function () {
                    return [
                      _c("S3Image", {
                        class: [
                          _vm.defaultImageClasses,
                          _vm.avatarStyleClasses,
                        ],
                        attrs: { s3FileKey: _vm.image },
                      }),
                    ]
                  },
                  {
                    defaultClasses: [
                      _vm.defaultImageClasses,
                      _vm.avatarStyleClasses,
                    ],
                    image: _vm.image,
                  }
                ),
              ]
            : [
                _vm._t(
                  "initial",
                  function () {
                    return [
                      _c(
                        "span",
                        {
                          class: [
                            _vm.defaultInitialsClasses,
                            _vm.avatarStyleClasses,
                          ],
                          style: _vm.bgStyle,
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-sm leading-none text-white" },
                            [_vm._v(_vm._s(_vm.initial))]
                          ),
                        ]
                      ),
                    ]
                  },
                  {
                    defaultClasses: [
                      _vm.defaultInitialsClasses,
                      _vm.avatarStyleClasses,
                    ],
                  }
                ),
              ],
          _vm.avatarOnly
            ? [
                _c(
                  "span",
                  {
                    staticClass: "tooltiptext",
                    style: `background-color: ${_vm.initialColor}`,
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      [
        !_vm.avatarOnly
          ? _c("div", { staticClass: "ml-2" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.title,
                      expression: "title",
                    },
                  ],
                  staticClass: "leading-5 whitespace-no-wrap",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.subtitle,
                      expression: "subtitle",
                    },
                  ],
                  staticClass: "text-sm leading-5 text-gray-500",
                },
                [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
              ),
            ])
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }